import React, { useState, useEffect } from "react";
import { Box, Tooltip, Typography } from "@mui/material";
import { ComposableMap, Geographies, Geography } from "react-simple-maps";
import { scaleLinear } from "d3-scale";
import axios from "axios";

// Sample India GeoJSON (you can replace it with your API or local file)
const INDIA_TOPOJSON = "https://raw.githubusercontent.com/geohacker/india/master/state/india_states.geojson";

// React component to display the map
const IndiaMap = () => {
	const [storeData, setStoreData] = useState({
		AndhraPradesh: 25,
		ArunachalPradesh: 5,
		Assam: 18,
		Bihar: 22,
		Chhattisgarh: 10,
		Goa: 8,
		Gujarat: 12,
		Haryana: 20,
		HimachalPradesh: 6,
		Jharkhand: 14,
		Karnataka: 15,
		Kerala: 18,
		MadhyaPradesh: 30,
		Maharashtra: 20,
		Manipur: 4,
		Meghalaya: 3,
		Mizoram: 2,
		Nagaland: 2,
		Odisha: 10,
		Punjab: 9,
		Rajasthan: 17,
		Sikkim: 2,
		TamilNadu: 18,
		Telangana: 14,
		Tripura: 3,
		UttarPradesh: 28,
		Uttarakhand: 5,
		WestBengal: 10,
	});
	const [tooltipContent, setTooltipContent] = useState("");

	// Fetch store data from the backend
	useEffect(() => {
		const fetchStoreData = async () => {
			try {
				const response = await axios.get("http://localhost:5000/api/store-count");
				setStoreData(response.data);
			} catch (err) {
				console.error("Error fetching store data:", err);
			}
		};

		fetchStoreData();
	}, []);

	// Color scale for store count
	const colorScale = scaleLinear()
		.domain([0, Math.max(...Object.values(storeData))])
		.range(["#e0f2f1", "#00796b"]);

	return (
		<Box sx={{ textAlign: "center", mt: 4 }}>
			<Typography variant="h5" gutterBottom>
				Store Count Per State
			</Typography>
			<ComposableMap projection="geoMercator" projectionConfig={{ scale: 1000, center: [80, 22] }}>
				<Geographies geography={INDIA_TOPOJSON}>
					{({ geographies }) =>
						geographies.map((geo) => {
							const stateName = geo.properties.st_nm; // Name of the state from GeoJSON
							const storeCount = storeData[stateName] || 0; // Fetch store count from backend data

							return (
								<Tooltip key={geo.rsmKey} title={`${stateName}: ${storeCount} Stores`} arrow>
									<Geography
										geography={geo}
										onMouseEnter={() => setTooltipContent(`${stateName}: ${storeCount} Stores`)}
										onMouseLeave={() => setTooltipContent("")}
										style={{
											default: {
												fill: colorScale(storeCount), // Color based on store count
												stroke: "#FFF",
												strokeWidth: 0.5,
											},
											hover: { fill: "#FF5722", stroke: "#FFF", strokeWidth: 1 },
											pressed: { fill: "#D84315" },
										}}
									/>
								</Tooltip>
							);
						})
					}
				</Geographies>
			</ComposableMap>
			<Typography variant="subtitle1" mt={2}>
				{tooltipContent}
			</Typography>
		</Box>
	);
};

export default IndiaMap;
